import {
  MutationFunction,
  QueryFunction,
  QueryKey,
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
} from "@tanstack/react-query";

export const useAppMutation = <
  TData = unknown,
  TError = unknown,
  TVariables = unknown,
  TContext = unknown
>(
  mutationFn: MutationFunction<TData, TVariables>,
  mutationOptions: UseMutationOptions<TData, TError, TVariables, TContext> = {}
) => useMutation(mutationFn, mutationOptions);

export const useAppQuery = <TQueryKey extends QueryKey, TQueryFnData = unknown>(
  queryKeys: TQueryKey,
  queryFn: QueryFunction<TQueryFnData, TQueryKey>,
  options: Omit<
    UseQueryOptions<TQueryFnData, TypeError, TQueryFnData, TQueryKey>,
    "queryKey" | "queryFn" | "initialData"
  > = {}
) => useQuery(queryKeys, queryFn, options);
